import { LOOK_CATEGORY_IDS, LOOK_COLOR_IDS, decodeLook, type CharacterLook, type LookColor } from "@tiny-seas/shared";
import type { SpawnOptions } from "./models.ts";

/** The look the player built in the Character creator; sent when joining the sea. */
export const LOOK_STORAGE_KEY = "tiny-seas.look.v1";

/** Material slots each look colour tints (bone shares the skin colour without its translucency). */
const COLOR_SLOTS: Readonly<Record<LookColor, readonly string[]>> = {
  skin: ["skinTone", "boneTone"], hairColor: ["hairTone"], eyeColor: ["irisTone"],
};

/** This browser's saved look code, or "" (classic crewmate) when none is saved or it is invalid. */
export function savedLookCode(): string {
  const code = typeof localStorage === "undefined" ? null : localStorage.getItem(LOOK_STORAGE_KEY);
  return code && decodeLook(code) ? code : "";
}

/** Variants and tint colours for `spawnModel("crewmate_custom", …)`. */
export function lookSpawnOptions(look: CharacterLook, coat: string): SpawnOptions {
  const variants: Record<string, string> = {};
  for (const category of LOOK_CATEGORY_IDS) variants[category] = look[category];
  const colors: Record<string, string> = { coat };
  for (const key of LOOK_COLOR_IDS) for (const slot of COLOR_SLOTS[key]) colors[slot] = look[key];
  return { colors, variants };
}
